export class RenameAccount {

	success: boolean;
	message: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/model/rename-account.ts